import { render } from "./partnerTr2.vue?vue&type=template&id=749544f0&scoped=true"
import script from "./partnerTr2.vue?vue&type=script&lang=js"
export * from "./partnerTr2.vue?vue&type=script&lang=js"

import "./partnerTr2.vue?vue&type=style&index=0&id=749544f0&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749544f0"]])

export default __exports__